// Vue
import Vue from "vue";

// Mixins
import UrlBuilderMixin from "./UrlBuilderMixin";
import UsuarioMixin from "./UsuarioMixin";
import FormatadorMixin from "./FormatadorMixin";
import IconesSvg from "../../shared/assets/icones/index";

class BaseMixin {
  Start() {
    let globalData = new Vue({
      data: {
        $appConfig: {}
      }
    });

    Vue.mixin({
      mixins: [UrlBuilderMixin, UsuarioMixin, FormatadorMixin, IconesSvg],
      computed: {
        $appConfig: {
          get: function() {
            return globalData.$data.$appConfig;
          },
          set: function(newConfig) {
            globalData.$data.$appConfig = newConfig;
          }
        }
      },
      methods: {
        sleep(ms) {
          return new Promise(resolve => setTimeout(resolve, ms));
        }
      }
    });
  }
}

export default new BaseMixin();
